import { WaitForEventStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { supportedWaitForEventTypes } from "@redotech/redo-flows-core-schema-common/common";
import { t } from "@redotech/redo-i18n";
import { FrontendStepType, PartialWithRequiredType } from ".";
import { getPrettyEventName } from "../utils/event-utils";

export const validateWaitForEventStep = (
  step: PartialWithRequiredType<WaitForEventStep>,
) => {
  return !!step.eventType;
};

export const waitForEventStepType: FrontendStepType<
  PartialWithRequiredType<WaitForEventStep>
> = {
  valid: validateWaitForEventStep,
  type: "standard",
  inspectorFactory: (props) => ({
    header: { title: t("Wait for event") },
    sections: [
      {
        fields: [
          {
            path: "eventType",
            label: t("Event Type"),
            widget: "select",
            disabledIf: () => true, //We are temporarily only supporting one event type
            options: supportedWaitForEventTypes.map((type) => {
              return { name: type, displayName: getPrettyEventName(type) };
            }),
          },
        ],
      },
    ],
  }),
};
